import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import Header from './components/Header';
import Hero from './components/Hero';
import Introduction from './components/Introduction';
import Services from './components/Services';
import About from './components/About';
import Tracking from './components/Tracking';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Login from './components/Login';
import AdminPanel from './components/admin/AdminPanel'; // Our new admin component

import './App.css';
import './styles/bootstrap.css';
import './styles/style.css';
import './styles/responsive.css';

function App() {
  // Authentication state
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // Check if user was previously authenticated (using localStorage)
  useEffect(() => {
    const authStatus = localStorage.getItem('isAuthenticated');
    if (authStatus === 'true') {
      setIsAuthenticated(true);
    }
  }, []);

  // Handle successful login
  const handleLoginSuccess = () => {
    setIsAuthenticated(true);
    localStorage.setItem('isAuthenticated', 'true');
  };

  // Handle logout
  const handleLogout = () => {
    setIsAuthenticated(false);
    localStorage.removeItem('isAuthenticated');
  };

  return (
    <Router>
      <div className="App">
        <Header isAuthenticated={isAuthenticated} onLogout={handleLogout} />
        <Routes>
          {/* Public Routes */}
          <Route
            path="/"
            element={
              <>
                <Hero />
                <Introduction />
                <Services />
                <Tracking />
                <Testimonials />
              </>
            }
          />
          <Route path="/about-us" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact" element={<Contact />} />
          
          {/* Authentication Route */}
          <Route 
            path="/login" 
            element={
              isAuthenticated ? 
                <Navigate to="/admin" /> : 
                <Login onLoginSuccess={handleLoginSuccess} />
            } 
          />
          
          {/* Protected Admin Routes */}
          <Route 
  path="/admin/*" 
  element={
    isAuthenticated ? (
      <AdminPanel onLogout={handleLogout} />
    ) : (
      <Navigate to="/login" replace />
    )
  } 
/>
          
          {/* Catch-all Route */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;